exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-molecules-QuizScore-___QuizScore__container___8hDa5 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-radius: 10px;\n  background-color: #f3f3f3;\n}\n\n.src-pc-components-molecules-QuizScore-___QuizScore__l-correct___3jurH {\n  margin: 0 8px;\n}\n\n.src-pc-components-molecules-QuizScore-___QuizScore__l-time___2uAol {\n  margin: 0 8px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-pc-components-molecules-QuizScore-___QuizScore__container___8hDa5",
	"l-correct": "src-pc-components-molecules-QuizScore-___QuizScore__l-correct___3jurH",
	"l-time": "src-pc-components-molecules-QuizScore-___QuizScore__l-time___2uAol"
};